var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "virtual-tour" }, [
    _c("iframe", {
      staticClass: "virtual-tour embed-responsive-item",
      attrs: {
        src: _vm.src,
        bordersize: "0",
        allowfullscreen: "true",
        allow: "vr,gyroscope,accelerometer"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }